import Reveal from "../components/Reveal";

export default function CareerTerms() {
  return (
    <div data-testid="career-terms-page" className="pt-32 pb-20">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <Reveal><h1 className="text-5xl font-bold">Career <span className="flame-text">Terms & Conditions</span></h1></Reveal>
        <Reveal delay={0.1}><p className="text-zinc-400 mt-4">Last updated: {new Date().toLocaleDateString()}</p></Reveal>
        <Reveal delay={0.2}>
          <div className="space-y-6 text-zinc-300 leading-relaxed mt-8">
            <Sec title="1. Eligibility">By applying you confirm you are at least 18 years old (or have applicable guardian consent for internships) and legally permitted to work in your jurisdiction.</Sec>
            <Sec title="2. Documents you submit">You agree the photograph, resume and government ID submitted are genuine and belong to you. Falsification leads to immediate disqualification.</Sec>
            <Sec title="3. Use of submitted data">Submitted data is used only for the purposes of evaluation and onboarding at Codeflare Labs and is retained for up to 24 months unless you request earlier deletion.</Sec>
            <Sec title="4. Selection process">Selection involves screening, interviews and (where applicable) a paid or unpaid technical assessment. Outcomes are communicated within 21 working days.</Sec>
            <Sec title="5. Compensation & benefits">Final offers will specify CTC/stipend, working hours, leave policy and benefits. Verbal indications during interviews are non-binding until an offer letter is issued.</Sec>
            <Sec title="6. Confidentiality">Any internal materials shared during interviews/internships remain the confidential property of Codeflare Labs.</Sec>
            <Sec title="7. Equal opportunity">Codeflare Labs hires solely on merit and does not discriminate on the basis of gender, religion, caste, sexual orientation or disability.</Sec>
            <Sec title="8. Right to amend">We may update these terms; the latest version always lives on this page.</Sec>
            <Sec title="9. Contact">For questions write to <a className="text-[#FF6B1A]" href="mailto:contact@codeflarelabs.com">contact@codeflarelabs.com</a>.</Sec>
          </div>
        </Reveal>
      </div>
    </div>
  );
}

function Sec({ title, children }) {
  return (
    <div>
      <h2 className="text-xl font-semibold text-white mb-2">{title}</h2>
      <p>{children}</p>
    </div>
  );
}
